import { ENVIRONMENT } from "./environment"

export const ApiToken = 'eXES98T1amxZB4E2wC9U1odpP0rFKdKk9iLApuLOaCue4M5Ahov0nP3Hz52RoUqjmWWqIv0am69dG55II2lL1KTUgr6RA6dtkI50ewcUTNbW1hlmruwH8vf7W5h1Gj5m';


const stngs = {
	DEVELOPMENT: {
		baseUri: 'https://dev.frankwatching.com/api/v1'
	},
	ACCEPTANCE: {
		baseUri: 'https://acc.frankwatching.com/api/v1'
	},
	PRODUCTION: {
		baseUri: 'https://www.frankwatching.com/api/v1'
	}
};

export const apiSettings = stngs[ENVIRONMENT];


// WEBPACK FOOTER //
// ./src/config/api.js